import { render } from "./Title.vue?vue&type=template&id=0a8a20c9&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=0a8a20c9&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/Komus-Tech/jobs/Build_And_Deploy_Komustech/workspace/komus-tech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8a20c9"]])

export default __exports__